import page0 from "./_0_preliminary_questions";
import page1 from "./_1_application_information";
import page2 from "./_2_employer_information";
import page3 from "./_3_employer_poc_information";
import page4 from "./_4_agent_or_attorney_information";
import page5 from "./_5_job_information_and_supporting_documentation";
import page6 from "./_6_declaration_of_employer_or_agent_attorney";
import page7 from "./_7_preparer_information";
import page8 from "./_8_additional_contacts_info";
import page9 from "./_9_foreign_labor_rec_info";
import appDocumentsPage from "./_10_application_documents";

const form_meta = {
  code: "Form ETA-9142A",
  name: "H-2A Application for Temporary Employment Certification",
  version: "Processed under 2024 H-2A Farmworker Protection Final Rule",
};

const form_nav = [
  {
    name: "Preliminary Questions",
    symbol: "list",
  },
  {
    name: "Nature of H-2A Application",
    prefix: "A",
  },
  {
    name: "Employer Information",
    prefix: "B",
  },
  {
    name: "Employer Point of Contact Information",
    prefix: "C",
  },
  {
    name: "Attorney or Agent Information <br/>(if applicable)",
    prefix: "D",
  },
  {
    name: "Job Opportunity and <br/> Supporting Documentation",
    prefix: "E",
  },
  {
    name: "Declaration of Employer and <br/> Attorney/Agent",
    prefix: "F",
  },
  {
    name: "Preparer",
    prefix: "G",
  },
  {
    name: "Additional Contact Information",
    prefix: "APX <br/>C",
    classes: "label-prefix-appx",
  },
  {
    name: "Foreign Labor Recruiter Information",
    prefix: "APX <br/>D",
    classes: "label-prefix-appx",
  },
  {
    name: "Application Documents",
    symbol: "upload",
  },
];

export { form_meta, form_nav };

export default [
  page0,
  page1,
  page2,
  page3,
  page4,
  page5,
  page6,
  page7,
  page8,
  page9,
  appDocumentsPage,
];
